import { Component, Input } from '@angular/core';
import { GamificationSettingsDto } from '../../shared/types/GamificationSettingsDto';
import { GamificationProfileDto } from '../../shared/types/GamificationProfileDto';
import { LeaderboardResultType } from '../../shared/types/leaderboard-result-type';

@Component({
  selector: 'lp2-inactive-ticket',
  templateUrl: './inactive-ticket.component.html',
  styleUrls: ['./inactive-ticket.component.scss'],
})
export class InactiveTicketComponent {
  @Input()
  gamificationProfile: GamificationProfileDto;

  @Input()
  set gamificationSettings(data: GamificationSettingsDto) {
    if (data) {
      this.topQualify = data.promotionZoneIndex;
    }
  }

  leaderboardResultType = LeaderboardResultType;

  topQualify = 10;
}



// WEBPACK FOOTER //
// ./ts/app/progress/inactive-ticket/inactive-ticket.component.ts